import { Box, Button, Header, Link, Popover, SpaceBetween } from '@cloudscape-design/components';
import { CONTACT_EMAIL } from '../pages/contact';
import { LINK_GROUPS, LINKS_COPY, PANEL_LINKS, type PanelLink } from './growthPlatformsLinks';
import './linksPanel.css';

/**
 * The shell's links panel: the GP Hub's right-hand links (spec 2026-09-30-gp-hub-replacement
 * §5.2). It's shell chrome, so it's Cloudscape, not the front-door style.
 */
export default function LinksPanel() {
  return (
    <Box padding={{ horizontal: 'l', vertical: 'm' }}>
      <SpaceBetween size="l">
        <Header variant="h2">{LINKS_COPY.title}</Header>
        {LINK_GROUPS.map((group) => {
          const headingId = `gp-links-${group.id}`;
          return (
            <div key={group.id}>
              <Box variant="h3" padding={{ bottom: 'xs' }}>
                <span id={headingId}>{group.title}</span>
              </Box>
              {/* role="list": Safari/VoiceOver drops list semantics once list-style is none. */}
              <ul className="gp-links-list" aria-labelledby={headingId} role="list">
                {PANEL_LINKS.filter((l) => l.group === group.id).map((l) => (
                  <li key={l.id} className="gp-links-item">
                    <Link
                      href={l.href}
                      external
                      target="_blank"
                      rel="noopener noreferrer"
                      externalIconAriaLabel={LINKS_COPY.newTab}
                    >
                      {l.name}
                    </Link>
                    {l.note && <LinkNote link={l} note={l.note} />}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </SpaceBetween>
    </Box>
  );
}

/** The "i" next to a link with an access note, e.g. the Management Roster's AirTable note. */
function LinkNote({ link, note }: { link: PanelLink; note: string }) {
  return (
    <Popover
      triggerType="custom"
      size="medium"
      position="left"
      header={link.name}
      dismissAriaLabel={LINKS_COPY.closeNote}
      content={
        <SpaceBetween size="xs">
          <Box variant="p">{note}</Box>
          <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>
        </SpaceBetween>
      }
    >
      <Button variant="inline-icon" iconName="status-info" ariaLabel={`${LINKS_COPY.aboutPrefix} ${link.name}`} />
    </Popover>
  );
}
